import React, { useState } from 'react';
import { Menu, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import BurgerMenu from './BurgerMenu';
import { Link } from 'react-router-dom';

const TopNav: React.FC = () => {
  const { logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <>
      <nav className="bg-theme-primary shadow-sm border-b border-theme-primary fixed top-0 left-0 right-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Left - Burger Menu */}
            <div className="flex items-center">
              <button
                onClick={() => setIsMenuOpen(true)}
                className="p-2 rounded-md text-theme-secondary hover:text-theme-primary hover:bg-theme-tertiary focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500 transition-colors"
              >
                <Menu className="h-6 w-6" />
              </button>
            </div>

            {/* Center - Logo */}
            <div className="flex items-center">
              <Link to="/" className="text-xl font-bold text-theme-primary hover:text-primary-600 transition-colors">
                Saleneum
              </Link>
            </div>

            {/* Right - Logout */}
            <div className="flex items-center">
              <button
                onClick={handleLogout}
                className="p-2 rounded-md text-theme-secondary hover:text-theme-primary hover:bg-theme-tertiary focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500 transition-colors"
                title="Logout"
              >
                <LogOut className="h-6 w-6" />
              </button>
            </div>
          </div>
        </div>
              </nav>

      {/* Burger Menu */}
      <BurgerMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
};

export default TopNav; 